import GamesTimeLeft from "../../others/games/GamesTimeLeft";
import GamesCurrentScore from "../../others/games/GamesCurrentScore";

export default function GamesIndicators({gameTimeLeft, currentScore}) {
    // Used in Games to display top bar made of
    // timer/score block and leave game button

    // BUILD
    return (
        <div className={"flex flex-col space-y-[12px]"}>
            <GamesTimeLeft gameTimeLeft={gameTimeLeft} />
            <GamesCurrentScore currentScore={currentScore} />
        </div>
    );
}